'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function NoopNotifier() {}

_base2['default'].extend(NoopNotifier, {
    notify: function notify() {}
});

exports['default'] = NoopNotifier;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/notifiers/noop.js
 ** module id = 684
 ** module chunks = 0 1
 **/